import { Instance } from 'mobx-state-tree';
import { VisitAddedDtoModelBase } from './VisitAddedDtoModel.base';

/* The TypeScript type of an instance of VisitAddedDtoModel */
export interface VisitAddedDtoModelType extends Instance<typeof VisitAddedDtoModel.Type> {}

/* A graphql query fragment builders for VisitAddedDtoModel */
export { selectFromVisitAddedDto, visitAddedDtoModelPrimitives, VisitAddedDtoModelSelector } from './VisitAddedDtoModel.base';

/**
 * VisitAddedDtoModel
 */
export const VisitAddedDtoModel = VisitAddedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
